import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import {GetStatsChat} from '../../actions/index';

class Chat extends Component {
     static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);

    }
     componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetStatsChat(token);
    }

    render() {
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-title clearfix"><p className="pull-left">Chat</p></div>
                <div>
                    <div className="col-md-12">
                        <Link to={"chat/persons"} className="white-block common-list second clearfix">
                            <p>Persons</p>
                            <p> {this.props.chat.stats ? this.props.chat.stats.persons : ''} person</p>
                        </Link>
                        <Link to={"chat/special"} className="white-block common-list second clearfix">

                            <p>Chat for special events</p>
                            <p>{this.props.chat.stats ? this.props.chat.stats.special_events : ''} events</p>
                        </Link>

                    </div>
                </div>
                <div className="clearfix"></div>
            </div>

        );
    }
}

function  mapStateToProps(state) {
    return{
        chat: state.chat
    }
}
export default connect(mapStateToProps, {GetStatsChat})(Chat);



// WEBPACK FOOTER //
// ./src/components/chat/chat.js